module.exports = __webpack_public_path__ + "static/media/003-Informieren_ID_1.141eeaa9.mp3";